
/* global __CLIENT__ */

import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import exact from 'prop-types-exact';
import defaultTags from '../../jsx/data/default';

const Head = ({ title, meta, script, staticContext, canonicalPath }) => {
    const location = useLocation();

    const serverHost = staticContext?.request_host || 'www.antena1.com.br';


    const currentUrl = useMemo(() => {
        // inject the current url into the default meta tags for og:url
        if (__CLIENT__) {
            return `${window.location.protocol}//${window.location.hostname}${canonicalPath || window.location.pathname}`;
        }

        return `https://${serverHost}${canonicalPath || location.pathname}`;
    }, [serverHost, location.pathname, canonicalPath]);


    const mergedMeta = useMemo(() => {
        const defaultMeta = { ...defaultTags.meta, 'og:url': currentUrl };

        return { ...defaultMeta, ...meta };
    }, [meta, currentUrl]);

    const mappedMeta = useMemo(() => (
        Object.keys(mergedMeta).map((key) => {
            if (key.includes('og:') || key.includes('fb:')) {
            // all meta data that contain either og: or fb: will use "property",
                return { property: key, content: mergedMeta[key] };
            }

            // all others will be "name" (note, it seams to also be possible to combine those,
            // but I thought better to keep them separated (at least until there is a valid reason to change this))
            return { name: key, content: mergedMeta[key] };
        })
    ), [mergedMeta]);


    return (
        <Helmet
            titleTemplate="%s | Antena 1"
            title={title || defaultTags.title}
            meta={mappedMeta}
            script={script}
            link={[{ rel: 'canonical', href: currentUrl }]} // Note: if there will be ever other links, they needs mapping like the meta tags
        />
    );
};

Head.propTypes = exact({
    staticContext: PropTypes.object,
    title: PropTypes.string,
    meta: PropTypes.object,
    script: PropTypes.array,
    canonicalPath: PropTypes.string,
});

export default Head;
